import axios from 'axios';
import moment from 'moment';

import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import uniqBy from 'lodash/uniqBy';

import { HEADERS } from '../../constants';
/* istanbul ignore file */

export function generateSecurityKey() {
  return from(axios.post('/authentication/dichallenge/generateSecurityKey')).pipe(
    map(({ data }) => data)
  );
}
export function rememberDevice() {
  return from(axios.post('/authentication/dichallenge/remeberDevice')).pipe(
    map(({ data }) => data),
    map(({ data }) => {
      const { deviceId, expires, token } = data;

      const storedTokens = JSON.parse(window.localStorage.getItem(HEADERS.DEVICE_TOKENS) || '[]');
      const sortedTokens = [...storedTokens, { deviceId, token, expires }].sort(
        ({ expires: a }, { expires: b }) => moment(b) - moment(a)
      );
      const tokens = uniqBy(sortedTokens, 'deviceId');
      window.localStorage.setItem(HEADERS.DEVICE_TOKENS, JSON.stringify(tokens));

      const tokensHeader = tokens.reduce(
        (obj, { deviceId, token }) => ({ ...obj, [deviceId]: token }),
        {}
      );
      const commonHeaders = axios.defaults.headers.common;
      commonHeaders[HEADERS.DEVICE_TOKENS] = JSON.stringify(tokensHeader);

      return data;
    })
  );
}
export function validateSecurityKey(key) {
  return from(axios.post('/authentication/dichallenge/validateSecurityKey', key)).pipe(
    map(({ data }) => data)
  );
}
